import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { StatisticTimeRange } from '../Enums/StatisticTimeRange.enum';

import { StatisticsSalesVolumeByItemColumn } from './StatisticsSalesVolumeByItemColumn.entity';

export class StatisticSalesVoumeByItem<T extends EMode = EMode.entity> {
  /** Alias: start */
  start?: string;
  /** Alias: end */
  end?: string;
  /** Alias: timeSpanUnit */
  timeSpanUnit?: StatisticTimeRange;
  /** Alias: columnCount */
  columnCount?: number;
  /** Alias: columns */
  columns?: StatisticsSalesVolumeByItemColumn<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<StatisticSalesVoumeByItem> = {
  start: {
    alias: 'start',
  },
  end: {
    alias: 'end',
  },
  timeSpanUnit: {
    alias: 'timeSpanUnit',
  },
  columnCount: {
    alias: 'columnCount',
  },
  columns: {
    alias: 'columns',
    entity: Entities.statisticsSalesVolumeByItemColumn,
  },
  __typename: {
    alias: '__typename',
  },
};

export const statisticSalesVoumeByItemEntityDefinition: EntitiyDefinition<StatisticSalesVoumeByItem> =
  {
    local: {},
    remote: {
      queryName: 'statisticSalesAmountByItem',
      fragmentName: 'StatisticSalesVoumeByItem',
      withPaginationWrapper: false,
      params: [
        { name: 'rangeType', type: 'StatisticTimeRange!' },
        { name: 'rangeStart', type: 'Date!' },
        { name: 'rangeEnd', type: 'Date' },
        { name: 'onlyRaInvoices', type: 'Boolean' },
        { name: 'costCenterFilter', type: 'Int' },
        { name: 'customerCode', type: 'Int' },
      ],
    },
    fieldDefinitions: fields,
  };
